import StructuredTextParser from '@app-ila/components/Utility/StructuredTextParser';
import { Box, Flex, Text, Image } from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import { render } from 'datocms-structured-text-to-html-string';

/**
 *
 * @param {Object} card
 * @returns
 */
const GenWhoShouldSection = ({ card, mergeBottom, ...props }) => {
  return (
    <Flex {...props}>
      <Flex
        flexDir={{ base: 'column', md: 'column' }}
        mb={{ base: '10px', md: '0' }}
        alignItems={{ base: 'flex-start', md: 'flex-start' }}
      >
        <Box display={'block'}>
          <Image
            src={card?.thumbnail.url}
            alt={card?.thumbnail.alt || 'no image found'}
            mb={mergeBottom || '0px'}
          />
        </Box>
        <Text
          maxW={{ base: 152, md: 218 }}
          color="#FFF"
          fontFamily="var(--FedraSansStd-medium)"
          fontSize={"20px"}
          fontStyle="normal"
          fontWeight="500"
          lineHeight="24px"
          mb={mergeBottom || '0px'}
          display={{ base: 'contents', md: 'block' }}
        >
          {card?.title}
        </Text>
      </Flex>
      <StructuredTextParser
        color="#D4D4FA"
        fontFamily="var(--FedraSansStd-book)"
        fontSize={{ base: '16px', sm:"16px", md: '18px' }}
        fontStyle="normal"
        fontWeight="400"
        lineHeight={'160%'}
        str={render(card?.description)}
      />
    </Flex>
  );
};

export default GenWhoShouldSection;
